var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qr-code',{attrs:{"size":150,"text":_vm.url,"error-level":"L"}})
}
var staticRenderFns = []

export { render, staticRenderFns }